import { render, staticRenderFns } from "./busquedaPasaporte.vue?vue&type=template&id=b9432cc2&scoped=true"
import script from "./busquedaPasaporte.vue?vue&type=script&lang=js"
export * from "./busquedaPasaporte.vue?vue&type=script&lang=js"
import style0 from "./busquedaPasaporte.vue?vue&type=style&index=0&id=b9432cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9432cc2",
  null
  
)

export default component.exports